/* Schedule — buổi học tiếp theo, nút Zoom, và các buổi còn lại. */
import { Card, CardContent } from "@/components/ui/card"
import { Icon } from "@/components/icon"
import { EmptyState, Page, PageHeader, usePageTitle } from "@/components/page"
import { useClass } from "@/app/ClassLayout"
import { formatDisplayDate, pickNextSession, sessionDisplayTitle } from "@/lib/format"
import { ClassMeta, QuietDetails, ZoomButton } from "./start-awards/shared"

function When({ session }: { session: any }) {
  return (
    <span className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-muted-foreground">
      <span className="flex items-center gap-1.5"><Icon name="calendar" className="size-4" />{formatDisplayDate(session.session_date)}</span>
      <span className="flex items-center gap-1.5"><Icon name="clock" className="size-4" />{session.starts_at || "Chưa có giờ"}</span>
    </span>
  )
}

export default function SessionsPage() {
  const { data } = useClass()
  const course = data.class || {}
  const { next, rest } = pickNextSession(data.sessions || [])
  usePageTitle(`Schedule · ${course.course_name || "Lớp học"}`, "Lịch học và link Zoom của lớp.")

  return (
    <Page>
      <PageHeader eyebrow="Lịch học" title="Buổi tiếp theo" />
      {next ? (
        <Card className="bg-paper">
          <CardContent className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex min-w-0 flex-col gap-2">
              {sessionDisplayTitle(next) ? (
                <>
                  <p className="text-sm font-bold text-orange-strong">Buổi {next.session_number}</p>
                  <h2 className="font-heading text-2xl font-bold text-ink">{sessionDisplayTitle(next)}</h2>
                </>
              ) : (
                <h2 className="font-heading text-2xl font-bold text-ink">Buổi {next.session_number}</h2>
              )}
              <When session={next} />
            </div>
            <ZoomButton session={next} course={course} className="w-full sm:w-fit" />
          </CardContent>
        </Card>
      ) : (
        <EmptyState icon="calendar" title="Chưa có lịch học" description="Mentor sẽ cập nhật tại đây." />
      )}
      <QuietDetails summary="Lịch và hướng dẫn vào lớp">
        <ClassMeta course={course} />
        <p>Nên vào Zoom trước giờ học 5 phút.</p>
      </QuietDetails>
      {rest.length > 0 && (
        <QuietDetails summary={`Xem ${rest.length} buổi còn lại`}>
          <ul className="grid gap-3 sm:grid-cols-2">
            {rest.map((s: any) => (
              <li key={s.id} className="flex items-start gap-3 rounded-2xl border-[1.5px] border-line bg-paper p-4">
                <span className="grid size-10 shrink-0 place-items-center rounded-xl bg-soft font-heading font-bold text-orange-strong">
                  {String(s.session_number).padStart(2, "0")}
                </span>
                <span className="flex min-w-0 flex-col gap-1">
                  <strong className="font-semibold text-ink">{sessionDisplayTitle(s) || `Buổi ${s.session_number}`}</strong>
                  <When session={s} />
                </span>
              </li>
            ))}
          </ul>
        </QuietDetails>
      )}
    </Page>
  )
}
